const careerPage = {
  "career.watch.video": "Ver video",
  "career.get-ready": "Prepárate...",
};

const leagueChange = {
  "career.promotion.title": "¡Felicidades!",
  "career.promotion.subtitle": "Bienvenido a",

  "career.relegation.title": "Descendido",
  "career.relegation.subtitle": "Estás de vuelta en",
};

const careerStatus = {
  "career.status.no.briefing": "Cumple los objetivos para avanzar a la siguiente división",
  "career.status.progress.base": "{{ divisions }} Divisiones a la Liga {{ league }}",
  "career.status.progress.last": "Completa el desafío para alcanzar la Liga {{ league }}",
};

const careerTargets = {
  "career.targets.title": "Tus objetivos",
};

export const career = {
  ...careerPage,
  ...leagueChange,
  ...careerStatus,
  ...careerTargets,
};
